import { render, staticRenderFns } from "./VDropdownMenu.vue?vue&type=template&id=7474472c&"
import script from "./VDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./VDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./VDropdownMenu.vue?vue&type=style&index=0&id=7474472c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports